import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { SUTransitApprovalDecision, FormMode, Languages, ServiceStatus, SUIsmDepatureApprovalDecision } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { IsmRequestDepartureComponent } from '../ism-request-departure/ism-request-departure.component';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';

@Component({
  selector: 'app-ism-departure-approval',
  templateUrl: './ism-departure-approval.component.html',
  styleUrls: []
})
export class IsmDepartureApprovalComponent implements OnInit {

  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO:  BaseRequest//= new BaseRequest();
  decision = SUIsmDepatureApprovalDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  ISMDepartureApprovalForm: FormGroup;
  user: User = new User();
  agent: User = new User();
  smallunitRequestObj: SmallUnitRequest = new SmallUnitRequest();
  adminDecisionObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  showRequest = false;
  agentId: string;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @ViewChild('ISMRequestDeparture',{static: false}) ISMRequestDeparture: IsmRequestDepartureComponent;
  @Input() public isShow: boolean = true;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;

  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService,
    private SmallUnitServ: SmallUnitsServiceFE,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private SmallUnitAdminServ: SmallUnitsAdminService, private agentSrv: AgentService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }

    this.user = this.globalSrv.user;

  }

  ngOnInit() {

    this.buildForm();
  }

  buildForm() {
    this.ISMDepartureApprovalForm = this.formBuilder.group({
      ISMDecision: ['', [Validators.required]],
      ISMMoreInformation: ['', [Validators.required]],
    });
    // if (decision == SUISMDepartureApprovalDecision.Postpone) {
    //   this.ISMDepartureApprovalForm = this.formBuilder.group({
    //     Decision: ['', [Validators.required]],
    //     MoreInformation: ['', [Validators.required]],
    //   });
    // }
    // else if   (decision == SUISMDepartureApprovalDecision.Approve) {
    //   this.ISMDepartureApprovalForm = this.formBuilder.group({
    //     Decision: ['', [Validators.required]],
    //     MoreInformation: ['', [Validators.required]],
    //   });
    // }
  }
  changeDecision(value) {
    // this.buildForm(value);
    this.ISMDepartureApprovalForm.patchValue({
      ISMDecision: value
    });
    this.decisionValue = value;
  }

  get f() {
    return this.ISMDepartureApprovalForm.controls;
  }

  getBaseRequest() {
    this.SmallUnitServ.get(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.smallunitRequestObj = this.responseObj.Data;
          this.requestStatus = this.smallunitRequestObj.StatusId;
          this.agentId = this.smallunitRequestObj.RequestorId;
          this.isLoaded = true;
          if (history.state.data && history.state.data.isCompleted) {

            this.decisionValue = this.smallunitRequestObj.ISMarineActionId;
            this.buildForm();
            this.ISMDepartureApprovalForm.patchValue({
              ISMDecision: this.smallunitRequestObj.ISMarineActionId,
              ISMMoreInformation: this.smallunitRequestObj.ISMarineNotes
            });
            // if (this.smallunitRequestObj.SmallUnitTransitActionId == SUTransitApprovalDecision.Postpone) {
            //   this.buildForm(this.decisionValue);
            //   this.iSTransitApprovalForm.patchValue({
            //     ISMDecision: this.decisionValue,
            //     MoreInformation: this.smallunitRequestObj.ISNotes
            //   });
            // }
            // else {
            //   this.buildForm(this.decisionValue);
            //   this.iSTransitApprovalForm.patchValue({
            //     ISMDecision:  this.decisionValue,
            //   });
            // }
            this.formMode = FormMode.Readonly;
            this.ISMDepartureApprovalForm.disable();
          }

          else if(this.requestStatus == ServiceStatus.SmallUnit_PendingISMDepartureApproval_PendingFinalFees){
          this.formMode = FormMode.Add;
          this.ISMDepartureApprovalForm.enable();
          }
          else{
          this.formMode = FormMode.Readonly;
          this.ISMDepartureApprovalForm.disable();
          this.buildForm();
          this.ISMDepartureApprovalForm.patchValue({
            ISMDecision: this.smallunitRequestObj.ISMarineActionId,
            ISMMoreInformation: this.smallunitRequestObj.ISMarineNotes
          });
          // if (this.smallunitRequestObj.SmallUnitTransitActionId == SUTransitApprovalDecision.Postpone) {
          //   this.buildForm(this.decisionValue);
          //   this.iSTransitApprovalForm.patchValue({
          //     ISMDecision: SUTransitApprovalDecision.Postpone,
          //     MoreInformation: this.smallunitRequestObj.ISNotes
          //   });
          // }
          // else {
          //   this.buildForm(this.decisionValue);
          //   this.iSTransitApprovalForm.patchValue({
          //     ISMDecision: SUTransitApprovalDecision.Approve,
          //   });
          // }

         }
       }
      }    )
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.ISMDepartureApprovalForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;

   // this.adminDecisionObject = this.iSTransitApprovalForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.Id = this.baseRequestId;
    this.adminDecisionObject.ISMarineActionId = this.ISMDepartureApprovalForm.controls.ISMDecision.value;
    this.adminDecisionObject.ISMarineNotes = this.ISMDepartureApprovalForm.controls.ISMMoreInformation.value;
    // if (this.adminDecisionObject.ISActionId == SUTransitApprovalDecision.Postpone){
    //   this.adminDecisionObject.ISMarineNotes = this.iSTransitApprovalForm.controls.MoreInformation.value;
    // }

    this.SmallUnitAdminServ.ISMDepartureApprovalDecision(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.ISMDepartureApprovalForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
